import React from "react";
import HOC from "../../components/HOC";
import ReportingComponents from "../../components/screen/Reporting/Reporting";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { theme } from "../../components/constants/muiTheme";
import { ThemeProvider } from "@mui/material";

const Reporting = () => {
  return (
    <div className="">
      <PageTemplate
        header="Reporting"
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <ReportingComponents />
            </div>
          </ThemeProvider>
        }
        pageRole={5}
      />
    </div>
  );
};

export default HOC(Reporting);
